const calculateAgeinYearsMonths = (dob: Date): string => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  const birthYear = dob.getFullYear();
  const birthMonth = dob.getMonth() + 1;

  let years = currentYear - birthYear;
  let months = currentMonth - birthMonth;

  if (months < 0) {
    years -= 1;
    months += 12;
  }

  return `${years} y ${months} m`;
};

export default calculateAgeinYearsMonths;
